import React from "react";
import BillsTableCurrent from "./BillsTableCurrent";
import BillsTableArchive from "./BillsTableArchive";

const BillsTable = ({ sessionId, ...props }) => {
    if (sessionId > 1000) {
        return <BillsTableArchive sessionId={sessionId} {...props} />;
    } else {
        return <BillsTableCurrent sessionId={sessionId} {...props} />;
    }
};

export default BillsTable;